var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "form-group col-12" }, [
      _c("p", { staticClass: "font-weight-bold" }, [_vm._v("Select Video")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "models-wrapper" },
        _vm._l(_vm.getVideos, function(model, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "model-item",
              class: { active: _vm.activeModel === model.name }
            },
            [
              _c("div", { staticClass: "col-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-success",
                    on: {
                      click: function($event) {
                        return _vm.playSelectedVideo(model)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-play" })]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.changeSelectedModel(key, model)
                      }
                    }
                  },
                  [_vm._v("\n            Select\n          ")]
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(model.name))])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "preview-div", attrs: { id: "preview-div" } }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.hideVideoPreview()
              }
            }
          },
          [_vm._v("×")]
        ),
        _vm._v(" "),
        _c("video", {
          attrs: { controls: "", id: "selectedVideoPreview", src: "" }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f287eec", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f287eec","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/timeline-components/video.vue
// module id = null
// module chunks = 